import { render } from "./WhatsBtn.vue?vue&type=template&id=3f49cce1&scoped=true"
import script from "./WhatsBtn.vue?vue&type=script&lang=js"
export * from "./WhatsBtn.vue?vue&type=script&lang=js"

import "./WhatsBtn.vue?vue&type=style&index=0&id=3f49cce1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f49cce1"]])

export default __exports__